import React from 'react';
import styled from 'styled-components';

import { SCROLLABLE_CONTAINER_MOBILE_TEST_ID } from '../../constants';
import type { IScrollableContainer } from '../../types';

export const ScrollableMobileContainer = (
  props: IScrollableContainer,
): JSX.Element => {
  const { children } = props;

  return (
    <Wrapper data-testid={SCROLLABLE_CONTAINER_MOBILE_TEST_ID}>
      {children}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;

  width: 100%;
  padding: 0 8px;

  overflow-x: auto;

  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
    -webkit-appearance: none;
  }
  scrollbar-width: none; /* Hide scrollbar on Firefox */
  -ms-overflow-style: none; /* Hide scrollbar on IE and Edge */
`;

export default ScrollableMobileContainer;
